import { useMemo } from "react";
import { useQuery } from "@apollo/client/react";

import { StageCycleOverrideCountDocument } from "#app/lib/data";

/**
 * Server-side count of Projects in a Stage carrying their own update cycle.
 * Boards are filtered and paginated, so loaded rows can never stand in for
 * it. Lazy: fetched only while `enabled` (the pin menu is open).
 */
export function useStageCycleOverrideCount(
  stageId: string | undefined,
  enabled: boolean,
): number {
  const variables = useMemo(() => ({ id: stageId ?? "" }), [stageId]);
  const { data } = useQuery(StageCycleOverrideCountDocument, {
    variables,
    skip: !enabled || !stageId,
  });
  return data?.stage?.projectCycleOverrideCount ?? 0;
}
